export const ExternalLinks = (function () {
	'use strict';

	function init() {
		events();
	}

	function events() {
		$('body').on('click', 'a', function (event) {
			if (
				this.href.indexOf(window.location.host) < 0 &&
				this.href.indexOf('mailto') < 0 &&
				this.href.indexOf('tel:') < 0 &&
				this.href.indexOf('careers-marketwise') < 0 &&
				this.href.indexOf('investors.marketwise.com') < 0 &&
				this.href.indexOf('marketwise.com') < 0 &&
				this.href.indexOf('marketwise.gcs-web.com') < 0
			) {

				if ($(window).width() < 1160 && $(this).siblings('.sub-menu-toggle').length > 0) {
						return;
				}

				event.preventDefault();
				event.stopPropagation();
				window.open(this.href, '_blank');
			}
		});
	}

	return {
		init: init,
	};
})();
